// https://swiperjs.com/get-started
import SwiperCore, {
    Navigation,
    Pagination,
    Autoplay,
    EffectFade,
    Thumbs,
} from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
import 'swiper/swiper-bundle.css';

const swiper = new SwiperCore('.swiper-container', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    autoplay: {
        delay: 4000,
    },
    speed: 1500,
    effect: 'fade',

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    // scrollbar: {
    //     el: '.swiper-scrollbar',
    // },
});

var swiper1 = new SwiperCore('.mySwiper', {
    spaceBetween: 20,
    slidesPerView: 'auto',
    slidesPerView: 4,
    freeMode: false,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    direction: 'horizontal',
    watchSlidesVisibility: true,
    breakpoints: {
        // when window width is >= 320px
        // 640: {
        //     slidesPerView: 7,
        // },
        // when window width is >= 480px
        768: {
            direction: 'vertical',
        },
        // when window width is >= 640px
        1024: {
            direction: 'horizontal',
        },
        1280: {
            direction: 'vertical',
        },
    },
});
var swiper2 = new SwiperCore('.mySwiper2', {
    // spaceBetween: 10,
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },

    thumbs: {
        swiper: swiper1,
    },
});

// $(function () {
//     var galleryThumbs = new SwiperCore('.gallery-thumbs', {
//         centeredSlides: true,
//         centeredSlidesBounds: true,
//         direction: 'horizontal',
//         spaceBetween: 10,
//         slidesPerView: 3,
//         freeMode: false,
//         watchSlidesVisibility: true,
//         watchSlidesProgress: true,
//         watchOverflow: true,
//         breakpoints: {
//             480: {
//                 direction: 'vertical',
//                 slidesPerView: 3,
//             },
//         },
//     });
//     var galleryTop = new SwiperCore('.gallery-top', {
//         direction: 'horizontal',
//         spaceBetween: 10,
//         // navigation: {
//         //     nextEl: '.swiper-button-next',
//         //     prevEl: '.swiper-button-prev',
//         // },
//         // a11y: {
//         //     prevSlideMessage: 'Previous slide',
//         //     nextSlideMessage: 'Next slide',
//         // },
//         keyboard: {
//             enabled: true,
//         },
//         thumbs: {
//             swiper: galleryThumbs,
//         },
//     });
//     galleryTop.on('slideChangeTransitionStart', function () {
//         galleryThumbs.slideTo(galleryTop.activeIndex);
//     });
//     galleryThumbs.on('transitionStart', function () {
//         galleryTop.slideTo(galleryThumbs.activeIndex);
//     });
// });
